import React from "react";

function WhatisCWallet() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a Cryptocurrency Wallet</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A cryptocurrency wallet or crypto wallet is a digital tool
                  that enables users to securely store, send, and receive
                  cryptocurrencies, functioning as a critical gateway to
                  interacting with blockchain networks. Unlike traditional
                  wallets that physically hold cash, a crypto wallet stores the
                  public and private keys—unique cryptographic credentials used
                  to access and manage digital assets stored on the blockchain.
                  These keys are essential for verifying ownership and
                  authorizing transactions.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatisCWallet;
